const templateSidebar = {
  init: function () {
    this.accordion();
  },

  accordion: function () {
    const accordionActive = "accordion-open";

    $(".accordion__header").on("click", function (e) {
      e.preventDefault();

      const toggle = $(this);

      const open = !toggle.parent().hasClass(accordionActive);

      // Close all accordions
      $(".accordion__body").slideUp(250);
      $(".accordion").removeClass(accordionActive);

      // Open clicked accordion
      if (open) {
        toggle.next().slideDown(250);
        toggle.parent().addClass(accordionActive);
      }
    });
  },
};

export default templateSidebar;
